<template>
    <div>
        <div v-if="showcargando == true" id="cargando" wire:loading
            class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center ">
            <div class=" loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4 "></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>
        <v-form ref="form" v-model="validForm" lazy-validation>
            <v-row v-if="renderComponent">
                <v-col cols="12" id="container">
                    <vs-list v-if="aseguradoras.length > 0">
                        <label class="typo__label" style="text-align: center;">Aseguradora:</label>
                        <multiselect v-model="busqueda.aseguradora"
                            deselect-label="No se puede remover el valor seleccionado" selected-label="Seleccionado"
                            select-label="Seleccionar valor" track-by="clclave" label="clnombre"
                            placeholder="Seleccionar Aseguradora" :options="filteredOptions" :allow-empty="false"
                            @input="ObtenerFlotilla()" :disabled="buscar" @search-change="filterOptions"
                            :searchable="true" :internal-search="false">
                            <template slot="clear" slot-scope="">
                                <div class="multiselect__clear" v-if="busqueda.aseguradora != ''"
                                    @mousedown.prevent.stop="busqueda.aseguradora = ''"></div>
                            </template>
                        </multiselect>
                    </vs-list>
                    <v-divider class="ma-2"></v-divider>
                    <vs-list v-if="flotillas.length > 0">
                        <label class="typo__label" style="text-align: center;">Flotillas:</label>
                        <multiselect v-model="busqueda.flotilla"
                            deselect-label="No se puede remover el valor seleccionado" selected-label="Seleccionado"
                            select-label="Seleccionar valor" track-by="flclave" label="flnomcorto"
                            placeholder="Seleccionar Aseguradora" :options="flotillas" :allow-empty="false"
                            :disabled="buscar">
                            <template slot="clear">
                                <div class="multiselect__clear" v-if="busqueda.flotilla != ''"
                                    @mousedown.prevent.stop="busqueda.flotilla = ''"></div>
                            </template>
                        </multiselect>
                    </vs-list>
                    <v-divider v-if="flotillas.length > 0" class="ma-2"></v-divider>
                    <vs-list>
                        <label class="typo__label" style="text-align: center;">Rango de fechas:</label>
                        <div>
                            <!--<v-text-field label="Seleccione una fecha y hora"
                            prepend-icon="event"
                            readonly
                            v-model="dates"></v-text-field>-->
                            <VueCtkDateTimePicker v-model="dates" id="DatePicker" label="" buttonNowTranslation="Hoy"
                                format="YYYY-MM-DD" formatted="l" noWeekendDays noShortcuts right noLabel onlyDate
                                :maxDate="minfecha" range>
                            </VueCtkDateTimePicker>
                            <span style="color: red; display: none" id="opcError"> Debe seleccionar la fecha de inicio y
                                termino </span>
                        </div>

                        <!--<div>
                            <v-menu ref="menu"
                                    v-model="menu"
                                    :close-on-content-click="false"
                                    :return-value.sync="dates"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field v-model="fechas"
                                                  outlined
                                                  dense
                                                  v-bind="attrs"
                                                  v-on="on"
                                                  readonly></v-text-field>
                                </template>
                                <VueCtkDateTimePicker v-model="dates"></VueCtkDateTimePicker>-->
                        <!--<v-date-picker v-model="dates"
                        locale="es-mx"
                        :max="minfecha"
                        range></v-date-picker>-->
                        <!--<v-spacer></v-spacer>
                                <v-btn text
                                       color="primary"
                                       @click="menu = false">
                                    Cancel
                                </v-btn>
                                <v-btn text
                                       color="primary"
                                       @click="$refs.menu.save(dates)">
                                    OK
                                </v-btn>

                            </v-menu>
                            <span style="color: red; display: none" id="opcError"> Debe seleccionar la fecha de inicio y termino </span>
                        </div>-->
                    </vs-list>
                    <v-divider></v-divider>
                    <v-list v-if="estados.length > 0">
                        <label class="typo__label" style="text-align: center;">Estado:</label>
                        <multiselect v-model="busqueda.estado"
                            deselect-label="No se puede remover el valor seleccionado" selected-label="Seleccionado"
                            select-label="Seleccionar valor" track-by="esclave" label="esnombre"
                            placeholder="Seleccionar Estado" :options="estados" :allow-empty="false" :disabled="buscar">
                            <template slot="clear" slot-scope="">
                                <div class="multiselect__clear" v-if="busqueda.estado != ''"
                                    @mousedown.prevent.stop="busqueda.estado = ''"></div>
                            </template>
                        </multiselect>
                    </v-list>
                    <v-divider class="ma-2" v-if="Tipo !== 'Civil'"></v-divider>
                    <v-list v-if="gerencias.length > 0 && Tipo !== 'Civil'">
                        <label class="typo__label" style="text-align: center;">Gerencia:</label>
                        <multiselect v-model="busqueda.gerencia"
                            deselect-label="No se puede remover el valor seleccionado" selected-label="Seleccionado"
                            select-label="Seleccionar valor" track-by="geclave" label="genombre"
                            placeholder="Seleccionar Gerencia" :options="gerencias"
                            @input="obtenerSupervisoriaPorGerencia(), obtenerAbogados()" :disabled="disagerencia">
                            <template slot="clear" slot-scope="">
                                <div class="multiselect__clear" v-if="busqueda.gerencia != ''"
                                    @mousedown.prevent.stop="busqueda.supervisoria = '', busqueda.abogado = ''"></div>
                            </template>
                        </multiselect>
                        <v-divider class="ma-2"></v-divider>
                    </v-list>
                    <v-list v-if="supervisorias.length > 0 && Tipo !== 'Civil'">
                        <label class="typo__label" style="text-align: center;">Supervisoria:</label>
                        <multiselect v-model="busqueda.supervisoria"
                            deselect-label="No se puede remover el valor seleccionado" selected-label="Seleccionado"
                            select-label="Seleccionar valor" track-by="suclave" label="sunombre"
                            placeholder="Seleccionar Supervisoria"
                            :options="busqueda.gerencia != '' ? supervisoriasTemp : supervisorias"
                            @input="obtenerAbogados()" :allow-empty="false" :disabled="disasupervisor">
                            <template slot="clear" slot-scope="">
                                <div class="multiselect__clear" v-if="busqueda.supervisoria != ''"
                                    @mousedown.prevent.stop="busqueda.supervisoria = '', busqueda.abogado = ''"></div>
                            </template>
                        </multiselect>
                        <v-divider class="ma-2"></v-divider>
                    </v-list>
                    <vs-list justify="center">
                        <label class="typo__label" style="text-align: center;">Abogado:</label>
                        <multiselect v-model="busqueda.abogado"
                            deselect-label="No se puede remover el valor seleccionado" selected-label="Seleccionado"
                            select-label="Seleccionar valor" track-by="prclave" label="prnombre"
                            placeholder="Seleccionar Abogado" :options="abogados" :allow-empty="false"
                            :disabled="disaabogado">
                            <template slot="clear" slot-scope="">
                                <div class="multiselect__clear" v-if="busqueda.abogado != ''"></div>
                            </template>
                        </multiselect>
                        <br />
                        <div class="text-center" :class="inac">
                            <span class="white--text">{{ texto }}</span>
                        </div>
                        <v-checkbox v-model="activos" label="Mostrar abogados inactivos"></v-checkbox>
                    </vs-list>
                </v-col>
            </v-row>
            <v-row justify="center">
                <v-btn class="ma-2" :loading="loadingB" :disabled="loadingB" color="primary" title="Buscar"
                    @click="Buscar">
                    <template v-slot:loader>
                        <span class="custom-loader">
                            <v-icon light>mdi-cached</v-icon>
                        </span>
                    </template>
                    <span style='color: white;'>Buscar</span>
                </v-btn>
                <v-btn class="ma-2" :disabled="loadingB" title="Limpiar" color="default" @click="Limpiar()">
                    <template v-slot:loader>
                        <span class="custom-loader">
                            <v-icon light>mdi-cached</v-icon>
                        </span>
                    </template>
                    Limpiar
                </v-btn>
            </v-row>
        </v-form>
    </div>
</template>
<script>
import { mapGetters, mapState, mapMutations } from 'vuex';
import moment from "moment";
import General from "@/services/Operacion/Operacion.service.js";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import SidebarService from '@/services/shared/sidebar.service.js';

import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';

export default {
    props: {
        Tipo: '',
    },
    data() {
        return {
            renderComponent: true,
            dates: null,
            fechas: '',
            texto: 'Abogados activos',
            inac: 'green accent-4',
            validForm: true,
            showcargando: true,
            busqueda: {
                aseguradora: '',
                flotilla: '',
                estado: '',
                gerencia: '',
                supervisoria: '',
                abogado: '',
            },
            ver: true,
            aseguradoras: '',
            estados: [],
            gerencias: [],
            abogados: [],
            supervisorias: [],
            abogadosTemp: [],
            supervisoriasTemp: [],
            flotillas: [],
            activos: false,
            menu: false,
            menu2: false,
            date: '',
            datefin: '',
            fecha: '',
            fechafin: '',
            minfecha: '',
            rules: {
                required: value => !!value || 'Campo requerido',
            },
            perabogado: false,
            perejecutivo: false,
            perexpestadistica: false,
            listado: 0,
            perfil: '',
            loadingB: false,
            loader: null,
            disagerencia: false,
            disasupervisor: false,
            disaabogado: false,
            buscar: false,
            datos: {},
            filteredOptions: [],
        }
    },
    methods: {
        ValidarFechaIni() {
            var resultRules = [];
            if (this.fecha == '' && this.fechafin != '') {
                resultRules.push(
                    (v) => 'Campo requerido'
                );
                return resultRules;
            }
            else if (moment(this.date) > moment(this.datefin)) {
                resultRules.push(
                    (v) => 'La fecha de inicio no debe ser mayor a la fecha de termino'
                );
                return resultRules;
            }
            else {
                return;
            }
        },
        ValidarFechaFin() {
            var resultRules = [];
            if (this.fechafin == '' && this.fecha != '') {
                resultRules.push(
                    (v) => 'Campo requerido'
                );
                return resultRules;
            }
            else if (moment(this.date) > moment(this.datefin)) {
                resultRules.push(
                    (v) => 'La fecha de termino no debe ser menor a la fecha de inicio'
                );
                return resultRules;
            }
            else {
                return;
            }
        },
        async Buscar() {
            this.$emit("Buscando");

            let filtrosRequerdos = this.Tipo === 'Civil' ? 1 : 2;
            let ban = 0;
            let banfecha = false;

            if (this.dates != null) {
                if (this.dates.start == null || this.dates.end == null) {
                    document.getElementById("opcError").style.display = "block";
                    banfecha = false;
                }
                else {

                    this.fecha = this.dates.start;
                    this.fechafin = this.dates.end;
                }
            } else {
                this.fecha = '';
                this.fechafin = '';
            }

            if (this.fecha != '' && this.fechafin != '') {
                ban++;
            }
            if (this.busqueda.aseguradora != '' && this.busqueda.aseguradora != null)
                ban++;
            if (this.busqueda.flotilla != '' && this.busqueda.flotilla != null)
                ban++;
            if (this.busqueda.estado != '' && this.busqueda.estado != null)
                ban++;
            if (this.busqueda.gerencia != '' && this.busqueda.gerencia != null)
                ban++;
            if (this.busqueda.supervisoria != '' && this.busqueda.supervisoria != null)
                ban++;
            if (this.busqueda.abogado != '' && this.busqueda.abogado != null)
                ban++;
            if (ban >= filtrosRequerdos) {
                this.RegistrarBusqueda();
                var all = document.querySelectorAll("#container select, #container input, #container textarea, #container button");
                for (let el of all) { el.disabled = true; }
                this.disagerencia = true;
                this.disasupervisor = true;
                this.disaabogado = true;
                this.buscar = true;

                this.loadingB = true;
                this.loader = true;
                this.listado = null;
                this.ver = true;
                this.busqueda.fecha = this.fecha; //this.date;
                this.busqueda.fechafin = this.fechafin;//this.datefin;
                this.busqueda.perfil = this.perfil;
                let formdata = new FormData();
                formdata.append("clclave", this.busqueda.aseguradora != null && this.busqueda.aseguradora != '' ? this.busqueda.aseguradora.clclave : null);
                formdata.append("flclave", this.busqueda.flotilla != '' ? this.busqueda.flotilla.flclave : null);
                formdata.append("fecini", this.fecha);
                formdata.append("fecfin", this.fechafin);
                formdata.append("esclave", this.busqueda.estado != '' ? this.busqueda.estado.esclave : null);
                formdata.append("geclave", this.busqueda.gerencia != null && this.busqueda.gerencia != '' ? this.busqueda.gerencia.geclave : null);
                formdata.append("suclave", this.busqueda.supervisoria != '' ? this.busqueda.supervisoria.suclave : null);
                formdata.append("prclave", this.busqueda.abogado != '' ? this.busqueda.abogado.prclave : null);
                formdata.append("tipo", this.Tipo);
                await General.ObtenerDatosAsistencia(this, formdata).then(data => {
                    this.listado = data;
                });
                this.loadingB = false;
                this.loader = false;
                var all = document.querySelectorAll("#container select, #container input, #container textarea, #container button");
                for (let el of all) { el.disabled = false; }

                this.disagerencia = this.perfil === 'A' || this.perfil === 'G' || this.perfil === 'S';
                this.disasupervisor = this.perfil === 'A' || this.perfil === 'S';
                this.disaabogado = this.perfil === 'A' && this.Tipo !== 'Civil';
                this.buscar = false;
                this.$emit("Respuesta", this.listado, this.busqueda);

            }
            else {
                let msg = filtrosRequerdos > 1 ? `Tiene que agregar al menos ${filtrosRequerdos} filtros para la búsqueda`
                    : `Tiene que agregar al menos un filtro para la búsqueda`

                this.$swal(
                    "Atención",
                    msg,
                    "info"
                );
            }

        },
        RegistrarBusqueda() {
            let arr = window.location.pathname.split("/");

            MetodosGenerales.registrarPaginaVisitada(
                'Estadistica', //modulo
                `Estadistica-${arr[arr.length - 1]}-Busqueda`,   //name
                window.location.origin + window.location.pathname, //   url
                this.domain.domainNameForApi,
                null,    //nrreporte,
                null//svindice
            );
        },

        async ObtenerFlotilla() {
            if (this.busqueda.aseguradora != null) {
                let form = new FormData();
                form.append("clclave", this.busqueda.aseguradora.clclave)
                await General.ObtenerFlotilla(this, form).then(data => {
                    this.flotillas = data;
                });
            }
        },

        async ObtenerPerfil() {
            await General.Perfil(this).then(data => {
                this.perfil = data[0].perfil;

                if (data[0].perfil == 'G') {
                    this.disagerencia = true;
                    this.busqueda.gerencia = this.gerencias.filter(item => item.geclave == data[0].valor)[0];
                    this.supervisoriasTemp = this.supervisorias.filter(item => item.geclave == this.busqueda.gerencia.geclave);
                }
                else if (data[0].perfil == 'S') {
                    this.disasupervisor = true;
                    this.disagerencia = true;
                    this.busqueda.gerencia = this.gerencias.filter(item => item.geclave == data[0].geclave)[0];
                    this.busqueda.supervisoria = this.supervisorias.filter(item => item.suclave == data[0].valor && item.geclave == data[0].geclave)[0];

                }
                else if (data[0].perfil == 'A') {
                    this.disagerencia = true;
                    this.disasupervisor = true;
                    this.disaabogado = true;
                    this.busqueda.gerencia = this.gerencias.filter(item => item.geclave == data[0].geclave)[0];
                    this.busqueda.supervisoria = this.supervisorias.filter(item => item.suclave == data[0].suclave && item.geclave == data[0].geclave)[0];
                    this.busqueda.abogado = this.abogados.filter(item => item.prclave == data[0].valor)[0];
                }
                else if (data[0].perfil == 'E') {
                    //this.busqueda.aseguradora = this.aseguradoras.filter(item => item.clclave = data[0].valor);
                }
                this.obtenerAbogados();
            });

        },
        async Limpiar() {
            this.busqueda = {
                aseguradora: '',
                flotilla: '',
                estado: '',
                gerencia: '',
                supervisoria: '',
                abogado: ''
            };
            this.ver = true;
            this.listado = null;
            this.flotillas = [];
            this.date = '';
            this.datefin = '';
            this.fecha = '';
            this.fechafin = '';
            this.$refs.form.reset();
            this.dates = null;
            await this.ObtenerPerfil();
            await this.obtenerAbogados();
            this.$emit("limpia");

        },
        ObtenerDatosJuridico() {
            let formdata = new FormData();
            formdata.append("clclave", this.busqueda.aseguradora);
            formdata.append("fecha", this.date);
            formdata.append("fehcafin", this.datefin);
            formdata.append("geclave", this.busqueda.gerencia);
            formdata.append("suclave", this.busqueda.supervisoria);
            formdata.append("prclave", this.busqueda.abogado);
        },
        obtenerSupervisoriaPorGerencia() {
            this.busqueda.supervisoria = '';
            this.abogadosTemp = [];
            this.busqueda.abogado = '';

            if (this.busqueda.gerencia != '' && this.busqueda.gerencia != null) {
                this.busqueda.supervisoria = '';
                this.busqueda.abogado = '';
                this.supervisoriasTemp = this.supervisorias.filter(item => item.geclave == this.busqueda.gerencia.geclave);

            }
        },
        async obtenerAbogados() {
            this.abogados = [];
            this.busqueda.abogado = '';
            let formdat = new FormData();
            formdat.append("suclave", this.busqueda.supervisoria == null || this.busqueda.supervisoria == '' ? null : this.busqueda.supervisoria.suclave);
            formdat.append("geclave", this.busqueda.gerencia == null || this.busqueda.gerencia.geclave == '' ? null : this.busqueda.gerencia.geclave);
            formdat.append("estatus", this.activos ? 'N' : 'A');
            await General.ObtenerAbogados(this, formdat).then(data => {
                if (data.length > 0)
                    this.abogados = data;
                else
                    this.abogados = [];
            });
        },
        async Permisos() {
            await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '23, 27,42').then(response => {
                if (response.data.length > 0) {
                    response.data.forEach(object => {
                        if (object.peclave == 23)
                            this.perabogado = true;
                        else if (object.peclave == 27)
                            this.perejecutivo = true;
                        else if (object.peclave == 42)
                            this.perexpestadistica = true;
                    });
                }
            });
        },
        formatDate(date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
        parseDate(date) {
            if (!date) return null

            const [day, month, year] = date.split('/')
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        },
        filterOptions(search) {
            if (!search) {
                this.filteredOptions = this.aseguradoras;
                return;
            }
            const term = this.normalize(search);
            this.filteredOptions = this.aseguradoras.filter(opt =>
                this.normalize(opt.clnombre).includes(term)
            );
        },
        normalize(str) {
            return str ? str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase() : '';
        },
    },
    computed: {
        ...mapState(['permission', 'domain']),
        ...mapGetters(['getUser', 'THEME_STATE']),

    },
    watch: {
        date(val) {

            this.fecha = this.formatDate(this.date);
        },
        datefin(val) {
            this.fechafin = this.formatDate(this.datefin);
        },

        async activos(val) {
            if (this.activos == true) {
                this.texto = 'Abogados inactivos';
                this.inac = 'rojo';
            }
            else {
                this.texto = 'Abogados activos';
                this.inac = 'green accent-4';
            }
            this.busqueda.abogado = '';
            let formdat = new FormData();
            this.obtenerAbogados()
        },
        'busqueda.aseguradora'() {
            if (this.busqueda.aseguradora == null)
                this.flotillas = '';
        },
        dates(val) {
            if (this.dates != null) {
                if (this.dates.start != null && this.dates.end != null) {
                    document.getElementById("opcError").style.display = "none";
                }
            }

        }

    },
    async created() {


    },
    async mounted() {
        this.minfecha = moment().format("YYYY[-]MM[-]DD");

        await this.Permisos();
        if (this.perexpestadistica || this.perabogado) {
            let formdata = new FormData();
            if (this.Tipo == 'Robo')
                formdata.append("aiclave", 24);
            else if (this.Tipo == 'RCMedico')
                formdata.append("aiclave", 5);
            else if (this.Tipo == 'Juridico')
                formdata.append("aiclave", 1);
            else if (this.Tipo == 'RVL')
                formdata.append("aiclave", 23);
            else if (this.Tipo === 'Civil')
                formdata.append("aiclave", 27);
            await General.Aseguradora(this, formdata).then(data => {
                this.aseguradoras = data;
                this.filteredOptions = this.aseguradoras;
            });
            await SidebarService.obtenerGerencias(this);
            await SidebarService.obtenerSupervisorias(this);

            await this.ObtenerPerfil();
            await SidebarService.obtenerEstados(this);
            this.showcargando = false;


        }
    },
    async forceRerender() {
        // Remove MyComponent from the DOM
        this.renderComponent = false;

        // Wait for the change to get flushed to the DOM
        await this.$nextTick();

        // Add the component back in
        this.renderComponent = true;
    }
}
</script>
<style scoped>
.custom-loader {
    animation: loader 1s infinite;
    display: flex;
}

@-moz-keyframes loader {
    from {
        transform: rotate(0);
    }

    to {
        transform: rotate(360deg);
    }
}

@-webkit-keyframes loader {
    from {
        transform: rotate(0);
    }

    to {
        transform: rotate(360deg);
    }
}

@-o-keyframes loader {
    from {
        transform: rotate(0);
    }

    to {
        transform: rotate(360deg);
    }
}

@keyframes loader {
    from {
        transform: rotate(0);
    }

    to {
        transform: rotate(360deg);
    }
}

.rojo {
    background-color: darkred;
}

.flex,
.child-flex>* {
    flex: 0 1 auto !important;
    max-width: 100%;
}
</style>
<!--<style lang="scss">
  .date-time-picker {
    width: 100%;
    margin: 0 auto;
    text-align: left;
    font-size: 14px;
    border-radius: 4px;
    position: relative;
    .time-picker-overlay {
      z-index: 2;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.4);
    }
  }

  @media screen and (max-width: 415px) {
    .time-picker-overlay {
      display: none;
    }
    .date-time-picker:not(.inline) {
      position: inherit !important;
    }
  }
</style>-->
